module.exports = __webpack_public_path__ + "img/IMG-20170324-WA0009.d2fbee17.jpg";